<template>
  <div class="selection_wrapper">
    <div class="form_group">
      <div
        :style="{color: activeColor}"
        class="selection"
        @click.stop="showSelection"
      >
        {{ initValue || '-请选择-' }}
      </div>
      <ul
        v-if="showOptions"
        class="options_list"
      >
        <li
          v-for="item in options"
          :key="item.value"
          :class="{'highlight': item.label === initValue}"
          @click="selectThis(item)"
        >
          {{ item.label }}
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { Message } from 'element-ui'
export default {
  name: 'BaseSelection',
  props: ['initValue', 'options', 'activeColor', 'errMsg'],
  data() {
    return {
      showOptions: false
    }
  },
  methods: {
    // 过滤菜单
    showSelection() {
      if (!this.options.length) {
        Message.info({ message: this.errMsg || '出错了' })
        return
      }
      this.showOptions = true
    },
    selectThis(item) {
      this.showOptions = false
      this.value = item.label
      this.$emit('selectCallback', item)
    }
  }
}
</script>
<style lang="less" scoped>
.selection_wrapper {
  width: 400px;
  line-height: 30px;
  border-radius: 2px;
  height: 30px;
  box-sizing: border-box;
  .form_group {
    position: relative;
  }
  .form_group::before {
    position: absolute;
    right: 10px;
    top: 60%;
    transform: translateY(-50%);
    content: "";
    width: 0;
    height: 0;
    border-width: 6px;
    border-color: #333 transparent transparent;
    border-style: solid dashed dashed;
  }
  .selection {
    width: 100%;
    height: 30px;
    padding: 0 10px;
    font-size: 14px;
    box-sizing: border-box;
    border: 1px solid #b7b7b7;
  }
  .options_list {
    padding: 5px 0;
    left: 0;
    top: 30px;
    right: 0;
    position: absolute;
    overflow: hidden;
    border: 1px solid #b7b7b7;
    border-radius: 2px;
    border-top: 0 none;
    background: #fff;
    z-index: 11;
    max-height: 150px;
    overflow: auto;
    li {
      list-style: none;
      padding: 5px 10px;
      font-size: 14px;
      color: #333;
      line-height: 20px;
      height: 20px;
      cursor: pointer;
      &:hover,
      &.highlight {
        background-color: #00ac8b;
        color: #fff;
      }
    }
  }
}
</style>
